import { MenuItem, TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, FieldValues, Path, get, FieldErrors } from 'react-hook-form';

export interface SelectOption {
  value: string;
  label: string;
}

/**
 * RHF-aware Select rendered as a MUI TextField with select=true.
 * Use this for static dropdowns (tenantType, role, etc.).
 */
type Props<T extends FieldValues> = Omit<TextFieldProps, 'name' | 'select' | 'error'> & {
  name: Path<T>;
  control: Control<T>;
  errors: FieldErrors<T>;
  options: readonly SelectOption[];
};

export function FormSelect<T extends FieldValues>({
  name,
  control,
  errors,
  options,
  helperText,
  fullWidth = true,
  ...rest
}: Props<T>) {
  const fieldError = get(errors, name) as { message?: string } | undefined;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...rest}
          {...field}
          select
          fullWidth={fullWidth}
          error={!!fieldError}
          helperText={fieldError?.message ?? helperText}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
}
